module.exports = __webpack_public_path__ + "static/media/bubble_5.d018af93.png";